import { render, staticRenderFns } from "./NoAccess.vue?vue&type=template&id=ff21d296"
import script from "./NoAccess.vue?vue&type=script&lang=js"
export * from "./NoAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports